import {
  PodcastImg,
  TrackCard as StyledTrackCard,
  TrackButtons,
  TrackTitle,
  TrackBody,
  Dot,
  TrackInfo,
} from "./styled";
import Typography from "../Typography";
import { useEffect, useRef, useState } from "react";
import useClickWithAuth from "../../hooks/useClickWithAuth";
import { useDispatch, useSelector } from "react-redux";
import IconLikeSvg from "../LikeTrackBtn/assets/IconLikeSvg";
import LikeTrackBtn from "../LikeTrackBtn";
import {
  selectCurrentContent,
  selectCurrentEntity,
} from "../../redux/selectors/playerSelector";
import { apiClient } from "../../api/api";
import { setCurrentContent } from "../../redux/Slice/playerSlice";
import toast from "react-hot-toast";
import { openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import { setInfoTrack } from "../../redux/Slice/trackInfoSlice";

export const TrackCard = ({ track, index, changeCurrentTrack }) => {
  const dispatch = useDispatch();
  const cardRef = useRef(null);
  const handleClickWithAuth = useClickWithAuth();
  const [like, setLike] = useState(true);
  const currentContent = useSelector(selectCurrentContent);
  const currentEntity = useSelector(selectCurrentEntity);

  const likeHandler = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const rate = like ? null : true;
    setLike((prev) => !prev);

    try {
      if (currentEntity === "track" && currentContent.id === track.id) {
        dispatch(setCurrentContent({ ...currentContent, user_rating: rate }));
      }

      if (rate) toast.success("Вы поставили лайк");
      else toast.success("Вы убрали лайк");

      await apiClient.post(`track/rate`, {
        rating: rate,
        track_id: Number(track.id),
      });
    } catch (error) {
      setLike((prev) => !prev);
      if (currentEntity === "track" && currentContent.id === track.id) {
        dispatch(setCurrentContent({ ...currentContent, user_rating: like }));
      }
    }
  };

  useEffect(() => {
    if (currentContent.id === track.id && currentEntity === "track") {
      const rating = currentContent["user_rating"];
      setLike(rating);
    }
  }, [currentContent, currentEntity, track.id]);

  const handleClick = () => {
    dispatch(setInfoTrack(track));
    dispatch(openModal(modalState.TRACK_INFO));
  };

  return (
    <StyledTrackCard
      ref={cardRef}
      duration={index * 500}
      tabIndex={0}
      onClick={handleClick}
    >
      <PodcastImg
        src={track.cover.small || "/coverMissing.png"}
        alt={track.title}
      />
      <TrackBody>
        <Typography variant="h4">{track.artist}</Typography>

        <TrackInfo>
          <Typography as={TrackTitle} component="span">
            {track.track}
          </Typography>

          {track.release && (
            <Typography component="span" color="secondary">
              <Dot>•</Dot> {`${track.release.split("-")[0]}г.`}
            </Typography>
          )}
        </TrackInfo>
      </TrackBody>
      <TrackButtons>
        <LikeTrackBtn onClick={handleClickWithAuth(likeHandler)} like={like}>
          <IconLikeSvg />
        </LikeTrackBtn>
      </TrackButtons>
    </StyledTrackCard>
  );
};
